import Vue from "vue";
import App from "./App.vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import VueAsyncComputed from "vue-async-computed";
import VueMoment from "vue-moment";
import VueSmoothScroll from "vue-smoothscroll";
import Vue2TouchEvents from "vue2-touch-events";
import VueAnalytics from "vue-analytics";
import VueI18n from "vue-i18n";
import VueMeta from "vue-meta";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueGoogleOAuth2 from "vue-google-oauth2";
import router from "./router";
import EventHub from "./plugins/EventHub";

Vue.config.productionTip = false;

Vue.use(VueAxios, Axios);
Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.log(error);
    return Promise.reject(error);
  }
);

Vue.use(VueAsyncComputed);
Vue.use(VueMoment);
Vue.use(VueSmoothScroll);
Vue.use(Vue2TouchEvents);
Vue.use(VueAnalytics, {
  id: "UA-142281638-1",
  router
});
Vue.use(VueI18n);
Vue.use(VueReCaptcha, {
  siteKey: "6LdZ9KoUAAAAAFxuA1keJDqAxam1eDwLO-MjFvG2",
  loaderOptions: {
    autoHideBadge: true
  }
});
Vue.use(VueGoogleOAuth2, {
  clientId:
    "986095607342-tkv34gp8i036ddp8nknbltv565c8ibk9.apps.googleusercontent.com",
  scope: "email",
  prompt: "select_account"
});
Vue.use(EventHub);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

const data = require("./message.json");
const i18n = new VueI18n({
  locale: localStorage.getItem("clip-lang") || "ja",
  messages: data
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
